import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { ModalReducerStateIdKeys, ModalStateReducerState } from "./reducer_interface";

const CustomerProfileModals = {
  CUSTOMER_PROFILE_APPOINTMENTS_TABLE_COMMENTS_VIEW_MORE: {},
  CUSTOMER_PROFILE_APPOINTMENTS_TABLE_COMMENTS_EDIT: {},
  NO_APP_SEND_REQUEST: {},
  LOGOUT: {},
  APPOINTMENT_CANCELATION: {},
  APPOINTMENT_RESCHEDULE: {},
  APPOINTMENT_RESCHEDULE_SHIFT: {},
  APPOINTMENT_REFUND: {},
  PWL_APPOINTMENT_ACTION: {},
  APPOINTMENTS_BOOK_AGAIN: {},
  CUSTOMER_PROFILE_MISSING_INFORMATION: {},
  CUSTOMER_PET_MISSING_DETAILS: {},
  NEW_SERVICE_MODAL: {},
  BOOKED_SLOTS_DETAILS: {},
  CLINIC_ONBOARD_CAPACITY: [],
  IMAGE_CATEGORY_MODAL: "",
  COPY_IMAGE_MODAL: {},
  EMR_IMAGE_UPLOAD_MODAL: {},
  MEMBERSHIP_USAGE_MODAL: {},
  PURCHASE_ORDER_REQUEST: {},
  ADD_ADDRESS_MODAL: {},
  NO_INTERNET_MODAL: {},
  BOOKING_MISSING_DETAILS_EDIT_MODAL: {},
  SELECT_CITY_AND_CLINIC_MODAL: {},
  EMR_OVERDRAFT_MODAL: {},
  EMR_QUICK_VIEW_MODAL: {},
  APP_VERSION_CHANGE_MODAL: {},
  EMR_VERIFY_PET_WEIGHT: {},
  INVENTORY_ONBOARD: {},
  ASK_AI_MODAL: {},
  EMR_SUBMISSION_MODAL: {},
  CALENDAR_BLOCK_DETAILS_MODAL: {},
  INVENTORY_SERVICE_CONFIGURE_CITY_MODAL: {},
  PRODUCT_CATALOGUE_ONBOARD_IMAGES_MODAL: {},
  SPEECH_RECOGNITION_MODAL: {},
  BULK_UPLOAD_MODAL: {},
  CREATE_PO_FROM_SHEET_MODAL: {},
  GOOD_TO_BAD_MODAL: {},
  BAD_INVENTORY_VIEW_IMAGE: {},
  PO_STATUS_UPDATE: {},
  PO_RAISE_ERROR_MODAL: {},
  GRN_STATUS_UPDATE: {},
  IS_OVERBOOKING_ALLOWED_MODAL: {},
  BOOKING_COMMENTS_MODAL: {},
  UI_THEME_CHANGE_MODAL: {},
  BOOKINGS_PAYMENT_STATUS: {},
  CART_ITEM_ADD_MODAL: {},
  CART_STOCK_INCOMPLETE_MODAL: {},
  CART_REMOVE_ITEM: {},
  LOGIN_WITH_OTP_MODAL: {},
  SHRINK_MODAL: {},
  MRP_UPDATE_MODAL: {},
  REQUEST_SAMPLE_PICKUP_MODAL: {},
  VACCINATION_ENTER_DATA_MODAL: {},
  PO_DELETE_MODAL: {},
  PO_COPY_PREVIOUS_MODAL: {},
  CERTIFICATE_DOCUMENT_UPLOAD_MODAL: {},
  CERTIFICATE_DOCUMENT_EDIT_MODAL: {},
  CERTIFICATE_DOCUMENT_VIEW_MODAL: {},
  CERTIFICATE_DOCUMENT_DELETE_MODAL: {},
  TO_SELECTED_ITEM_MODAL: {},
  VACCINATION_OVERDUE_MODAL: {},
  REJECT_REQUEST_MODAL: {},
  SHRINK_IMAGE_MODAL: {},
  INVALID_IMAGE: {},
  SERVICE_IMAGE_VIEW_MODAL: {},
  AT_HOME_ACTION_CONFIRM_MODAL: {},
  INVOICE_ADJUSTMENT_DETAILS_MODAL: {},
  INVOICE_ADJUSTMENT_PREVIEW_MODAL: {},
  TILE_ADD_MODAL: {},
  TILE_VIEW_MODAL: {},
  TILE_DELETE_MODAL: {},
  TILE_EDIT_MODAL: {},
  TILE_SYNC_MODAL: {},
  LAB_REPORT_INTERPRETATION_EMR_MODAL: {},
  LAB_REPORT_INTERPRETATION_REQUISITIONS_MODAL: {},
};

// Define the initial state using that type
const intialRootState: ModalStateReducerState = {
  ...CustomerProfileModals,
};

export const rootStateSlice = createSlice({
  name: "modal_states",
  initialState: intialRootState,
  reducers: {
    setModalStateData: (state, action: PayloadAction<{ key: ModalReducerStateIdKeys; data: any }>) => {
      state[action.payload.key as ModalReducerStateIdKeys] = action.payload.data;
    },
  },
});

export const { setModalStateData } = rootStateSlice.actions;

export default rootStateSlice.reducer;
